import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const apiClient = axios.create({ baseURL: API });

apiClient.interceptors.request.use((cfg) => {
  const token = sessionStorage.getItem("lk_token");
  if (token) cfg.headers.Authorization = `Bearer ${token}`;
  return cfg;
});

export default apiClient;

export const SERVICES_META = {
  photo_booth: {
    title: "Classic Photo Booth",
    tagline: "Timeless. Iconic. Unforgettable.",
    description:
      "Studio-quality photos, premium props, instant prints. Built for the moments worth keeping.",
    image:
      "https://images.unsplash.com/photo-1701112501523-bc9f48e3753e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHxwaG90byUyMGJvb3RoJTIwZXZlbnR8ZW58MHx8fHwxNzgxMzExMDM0fDA&ixlib=rb-4.1.0&q=85",
  },
  photo_booth_360: {
    title: "360° Photo Booth",
    tagline: "Slow-motion luxury, in full rotation.",
    description:
      "Cinematic 360° video capture with custom overlays, music, and instant share to socials.",
    image:
      "https://images.unsplash.com/photo-1746587224861-521244472226?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwyfHxwaG90byUyMGJvb3RoJTIwZXZlbnR8ZW58MHx8fHwxNzgxMzExMDM0fDA&ixlib=rb-4.1.0&q=85",
  },
};

export const GALLERY = [
  "https://images.unsplash.com/photo-1768508950778-9ba70d4445e9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBldmVudCUyMHBhcnR5JTIwZ2xhbW9yb3VzfGVufDB8fHx8MTc4MTMxMTAzNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1774543091182-d55b4a039d5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBldmVudCUyMHBhcnR5JTIwZ2xhbW9yb3VzfGVufDB8fHx8MTc4MTMxMTAzNHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1599652521984-8bebed0580b7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxwaG90byUyMHN0cmlwcyUyMHByaW50c3xlbnwwfHx8fDE3ODEzMTEwMzR8MA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1574770291411-a7ca092d0052?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxwYXJ0eSUyMHByb3BzJTIwbWFza3N8ZW58MHx8fHwxNzgxMzExMDM0fDA&ixlib=rb-4.1.0&q=85",
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1764255510960-deee566a91f0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBldmVudCUyMHBhcnR5JTIwZ2xhbW9yb3VzfGVufDB8fHx8MTc4MTMxMTAzNHww&ixlib=rb-4.1.0&q=85";

export const TRAVEL = {
  agentEmail: "sean.charles@inteletravel.com",
  selfServiceHref: "https://seancharles.inteletravel.com",
};

export const CONTACT = {
  phone: "+1 (854) 213-1814",
  phoneHref: "tel:+18542131814",
  email: "luxuryKingzLLC@outlook.com",
  emailHref: "mailto:luxuryKingzLLC@outlook.com",
  location: "North Charleston, SC",
  serviceArea: "Serving the Lowcountry & beyond",
};
